import defineService from './defineService';
const uploadNewDesign = defineService('post', 'spool/designs/', {
  suffixFunc(formData, flags)  {
    if (formData.get('is_template')) return '-template';
    if (flags.oneSided) return '-onesided';
    return '';
  },
  alternatives: {
    oneSided: '-onesided'
  }
});
const getDesign = defineService('get', 'spool/designs/:id/', {
  suffixFunc: id => ({777: '-template', 778: '-onesided'})[id] || ''
});
const getFontCss = defineService('post', 'fonts/get', {
  alternatives: {
    oneSided: '-onesided'
  }
});
const patchPage = defineService('patch', 'spool/pages/:id/');
export const deletePage = defineService('delete', 'spool/pages/:id/');
const patchLayer = defineService('patch', 'spool/layers/:id/');
const postDesignClone = defineService('post', 'spool/designs/clone');
const uploadNewPage = defineService('put', 'spool/designs/:id/pages');
const patchDesign = defineService('patch', 'spool/designs/:id/');
const putDesignUpdate = defineService('put', 'spool/designs/:id/update');

/**
 * Uploads file to service, creating a design.
 * Extra keys can be passed, to make templates etc.
 * If designId is passed in extra, add a new page
 * to the design.
 *
 * @param {FileTarget} file
 * @returns {Design}
 */
export async function upload(file, extra={}) {
  let method = uploadNewDesign;
  if (extra.designId) {
    // post new page
    let designId = extra.designId;
    delete extra.designId;
    method = (data) => uploadNewPage(designId, data);
  }
  var formData = new FormData();
  formData.append("file", file);
  for (let key in extra) {
    formData.append(key, ''+extra[key]);
  }
  try {
    var response = await method(formData)
  } catch(e) {
    // Unwrap the error from axios, if its an axios error.
    throw e.response ? e.response.data.file : e;
  }
  return response;
}

export async function load(id) {
  var response = await getDesign(id);
  return response;
}

export async function getFonts(id) {
  var response = await getFontCss({design: id});
  return response;
}

export async function updatePage(pageId, svgMarkup, previewDataUrl) {
  return patchPage(pageId, {id: pageId, svgMarkup, previewDataUrl});
}

export function updateLayerObjects(layerId, objects, meta) {
  return patchLayer(layerId, {id: layerId, layerInfo: {objects, meta}, svgMarkup: null, type: 2});
}

export function updateLayerSvg(layerId, svgMarkup) {
  return patchLayer(layerId, {id: layerId, svgMarkup});
}

export function productionFile(designId) {
  return getDesign(designId, {production: 1});
}

/**
 * Clones a template design, and returns the details of the new design.
 *
 * @param {id or url} source
 * @param {true or undefined} isTemplate
 */
export async function clone(source, isTemplate) {
  console.log('cloning', source);
  return postDesignClone({source, isTemplate});
}

export async function updateDesign(id, updates) {
  return patchDesign(id, updates);
}

export async function updateDesignTemplate(id, updates) {
  return putDesignUpdate(id, updates);
}



// WEBPACK FOOTER //
// ./src/services/design.js